import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ContingentBundle } from '../../store/contingent/model/contingent-bundle.model';
import { selectAllContingentBundles, selectContingentBundlesByName } from '../../store/contingent/contingent-bundle.selector';
import { ContingentBundleApiActions } from '../../store/contingent/contingent-bundle.actions';

@Injectable({
    providedIn: 'root'
})
export class ContingentFacadeService {
    contingentBundles$: Observable<ContingentBundle[]> = this.store.select(selectAllContingentBundles);

    constructor(private store: Store) {}

    loadContingentBundles(): void {
        this.store.dispatch(ContingentBundleApiActions.loadContingentBundles());
    }

    findContingentBundlesByName(searchString: string): Observable<ContingentBundle[]> {
        return this.store.select(selectContingentBundlesByName(searchString));
    }
}
